import React, { Component } from "react";
import MainPicture from "../Section/MainPicture";
import image from './img/application-mobile.png';
import LeftPictureBackground from "../Section/LeftPictureBackground";
import CheckModule from "../Section/CheckModule";
import picturemethodo from "./img/mobile-et-web-app.png";
import picturequality from "./img/natif-vs-hybrid.png";
import RightPicture from "../Section/RightPicture";
import pictureevol from "./img/mobile-hybrid.png";
import technologies from "../../../static/images/technologies.png";
import symfony from "../../pages/img/symfony.png";
import nodejs from "./img/nodejs.png";
import angular from "./img/angular-react.png";
import database from "./img/base-de-donnee.png";
import elasticsearch from "./img/elasticsearch.png";
import html from "./img/html-css-js.png";

class ApplicationMobile extends Component {
  render() {
    let alt = "Application mobile";
    let description = ["Nous réalisons des ", <strong>applications mobiles Apple iOS</strong>, " ou ", <strong>Google Android</strong>, " de qualité. "];


    let smalltitle = "Des propositions cohérentes";
    let titlemethodo = "Une offre complète";
    let descriptionmethodo = [
        "Bien souvent, afin de développer des ", <strong>applications mobiles dynamiques et administrables</strong>," il est nécessaire de créer une interface d'administration.",
        <br />, <br />, "En tant que Studio Web, nous prenons en charge 100% de la réalisation de votre interface d'administration, votre application ou ", <a href="/site-internet" title="Création de site web">site Internet</a>, " et votre application mobile."];
    let pictureMethodo = picturemethodo;
    let altmethodo = "Méthodologie agile Scrum en image";



    let smalltitleevol = "Des applications mobiles sur-mesure";
    let titleevol = "Le meilleur du mobile pour smartphone et tablette";
    let descriptionevol = ["Les applications mobiles sont devenues ", <strong>incontournables</strong>, " dans notre quotidien. C'est pourquoi, afin de compléter ", <a href="/application-web" title="Découvrir notre offre d'applications Web">notre offre d'application Web</a>, ", nous proposons de réaliser des applications mobiles performantes.", <br />,<br />,
"Nous utilisons des technologies qui nous permettent un maximum de réutilisation entre les applications Web et les applications Mobiles pour ", <strong>diminuer les coûts de développement</strong>, "."];

    let altevol = "Intégration du portail dans votre système d'information";


    let smalltitleCheck = "A chaque projet sa technologie" ;
    let titleCheck = "L'expertise mobile et applicative à votre service";
    let subtitle1Check = "Application native";
    let text1Check = ["Vous avez besoin de ", <strong>performance</strong>, " ? Vous avez de grands volumes à traiter ? Nous réalisons pour vous des applications natives (SWIFT, Objective C, Java).", <br/>,<i>1 développement par plateforme</i>];
    let subtitle2Check = "Application Hybride";
    let text2Check = ["Vous souhaitez ",<strong>diminuer les coûts</strong>," et rationaliser les développements ? Nous réalisons des applications Hybrides pour iOS et Android.",<br />,<i>1 développement pout toutes les plateformes</i>];
    let subtitle3Check = "Application Web";
    let text3Check = ["Nous réalisons des applications \"Mobile first\" appelé progressives apps, qui utilisent 100% des technologies web pour obtenir une application cohérente que ce soit sur votre PC, Tablette ou Smartphone.", <br />,<i>1 développement pour toutes les plateformes</i>];
    let pictureCheck = picturequality;
    let altCheck = "Le mobile à votre service";


    return (
      <div className="generic-services">
        <MainPicture title="La création d'application mobile 360°" description={description} picture={image} alt={alt} />
        <RightPicture smalltitle={smalltitleevol} title={titleevol} description={descriptionevol} picture={pictureevol} alt={altevol} />
        <LeftPictureBackground smalltitle={smalltitle} title={titlemethodo} description={descriptionmethodo} picture={pictureMethodo} alt={altmethodo} />
        <CheckModule 
                smalltitle={smalltitleCheck} 
                title={titleCheck}
                subtitle1={subtitle1Check}
                text1={text1Check}
                subtitle2={subtitle2Check}
                text2={text2Check}
                subtitle3={subtitle3Check}
                text3={text3Check}
                picture={pictureCheck}
                alt={altCheck}
        />

      </div>
    );
  }
}

export default ApplicationMobile;



// WEBPACK FOOTER //
// ./src/components/Page/ApplicationMobile.jsx